/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Trust_Support_DescInputs */

const en_home_trust_support_desc = /** @type {(inputs: Home_Trust_Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here when you need us most`)
};

const fr_home_trust_support_desc = /** @type {(inputs: Home_Trust_Support_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibles quand vous en avez le plus besoin`)
};

/**
* | output |
* | --- |
* | "Here when you need us most" |
*
* @param {Home_Trust_Support_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_trust_support_desc = /** @type {((inputs?: Home_Trust_Support_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Trust_Support_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_trust_support_desc(inputs)
	return fr_home_trust_support_desc(inputs)
});